export enum EnumSubTipoConfiguracion {
  Concepto = 1,
  Html = 2,
  Grafica = 3
}
